import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Store } from '@ngxs/store';
import { SetItem } from '@stores/secure/secure.actions';
import { SecureState } from '@stores/secure/secure.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class TokenGuard implements CanActivate {
  constructor(private readonly router: Router, private readonly store: Store) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {
    const token = route.queryParamMap.get(SecureState.LOCAL_MISSION_TOKEN);
    const eventId = route.paramMap.get('eventId');

    if (token) {
      this.store.dispatch(new SetItem(SecureState.LOCAL_MISSION_TOKEN, token));
      this.store.dispatch(new SetItem(SecureState.LOCAL_MISSION_EVENT_ID, eventId ?? ''));
      return true;
    }

    return this.store
      .selectOnce(SecureState.item(SecureState.LOCAL_MISSION_TOKEN))
      .pipe(map((tokenStorage) => (tokenStorage ? true : this.router.parseUrl(`/${FeaturesRoutingEnum.Employers}`))));
  }
}
